function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";

var FileForm = function FileForm(props) {
  var onSubmit = props.onSubmit,
      fileTypes = props.fileTypes,
      initialFileType = props.initialFileType,
      onCancel = props.onCancel;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      file = _React$useState2[0],
      setFile = _React$useState2[1];

  var _React$useState3 = React.useState(initialFileType || ""),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      fileType = _React$useState4[0],
      setFileType = _React$useState4[1];

  React.useEffect(function () {
    setFileType(initialFileType || "");
  }, [initialFileType]);

  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();

    if (file && fileType) {
      onSubmit(file, fileType);
      setFile(null);
      setFileType(""); // Reset file input

      var fileInput = document.getElementById("file-input");
      if (fileInput) fileInput.value = "";
    } else {
      alert("Por favor seleccione un archivo y un tipo");
    }
  };

  var handleFileChange = function handleFileChange(e) {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit,
    className: "file-form-compact",
    style: {
      display: "flex",
      flexDirection: "column",
      flex: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group",
    style: {
      marginBottom: "8px"
    }
  }, /*#__PURE__*/React.createElement("label", {
    style: {
      marginBottom: "3px",
      fontSize: "13px",
      fontWeight: "normal"
    }
  }, "Tipo de archivo"), /*#__PURE__*/React.createElement("select", {
    className: "form-control",
    value: fileType,
    onChange: function onChange(e) {
      return setFileType(e.target.value);
    },
    required: true,
    style: {
      fontSize: "13px"
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Seleccione un tipo"), fileTypes.map(function (type) {
    return /*#__PURE__*/React.createElement("option", {
      key: type.value,
      value: type.value
    }, type.label);
  }))), /*#__PURE__*/React.createElement("div", {
    className: "form-group",
    style: {
      marginBottom: "8px"
    }
  }, /*#__PURE__*/React.createElement("label", {
    style: {
      marginBottom: "3px",
      fontSize: "13px",
      fontWeight: "normal"
    }
  }, "Archivo"), /*#__PURE__*/React.createElement("input", {
    id: "file-input",
    type: "file",
    className: "form-control",
    onChange: handleFileChange,
    accept: ".pdf",
    required: !initialFileType,
    style: {
      fontSize: "13px",
      padding: "5px"
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "auto",
      display: "flex",
      gap: "8px",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: "10px"
    }
  }, onCancel && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-secondary btn-sm",
    onClick: onCancel
  }, "Cancelar"), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "btn btn-primary btn-sm"
  }, "Guardar")));
};

export default FileForm;